import Read from './Read.graphql';
import Programs from './Programs.graphql';
import Update from './Update.graphql';
import Create from './Create.graphql';
import Delete from './Delete.graphql';

export const ProgramReadQuery = Read;
export const ProgramsQuery = Programs;
export const ProgramUpdate = Update;
export const ProgramCreate = Create;
export const ProgramDelete = Delete;
